module.exports = __webpack_public_path__ + "static/media/jacobus-coaches.30f22072.jpg";